import * as React from "react";
import { forwardRef } from "react";
const SvgCollapse = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.16675 10.8334V15.8334H7.50008V12.5001H4.16675V10.8334H9.16675ZM12.5001 4.16675V7.50008H15.8334V9.16675H10.8334V4.16675H12.5001Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCollapse);
export { ForwardRef as ReactComponent };
